import {
  GlobalDesignGroupAction,
  GlobalDesignActionType,
  ComparisonMode,
} from '../types';
import { textGroupDisplayFilter } from './groupDisplayFilter';
import { textGrouping } from './grouping';
import TextLobbyItem from './TextLobbyItem';
import TextStyles from './TextStyles';

const textAction: GlobalDesignGroupAction = {
  type: GlobalDesignActionType.Group,
  panel: TextStyles,
  lobbyItem: TextLobbyItem,
  groupDisplayFilter: textGroupDisplayFilter,
  comparisonMode: ComparisonMode.DirectProps,
  grouping: textGrouping,
};

export default textAction;
